<template>
  <div class="content">
    <ul class="five">
      <li class="five-item" v-for="(item, index) in Media" :key="index">
        <div class="img-sty" style="position:relative;">
          <!-- <div @click="toPlays(index)" style="width:0px;height:0px;border: 15px solid transparent;border-left-color: #fff;position:absolute;left:170px;top:120px;z-index:9999;"></div> -->
          <a>
            <!-- <video class="img-wh" ref="videoPlayer" :src="item.videoPath" @play="toPlays"></video> -->
            <video :muted="true" :autoplay="false" controls ref="videoPlayer" style="width:360px;height:270px;">
              <source :src="item.videoPath" type="video/mp4">
            </video>
             </a>
        </div>
        <div class="five-mesage">
          <p style="font-size:20px;font-weight:bold;margin-bottom:28px;color:#000;">
            <a class="a1">{{ item.title }}</a>
            <img v-if=" item.needLogin === 1 " src="../../assets/lock_icon.png">
          </p>
          <p style="font-size:16px;margin-bottom:36px;color:#8d8d8d;">{{ item.created }}</p>
          <p class="p3" style="font-size:16px;margin-bottom:17px;color:#8d8d8d;line-height:30px;">{{ item.remark }}</p>
          <p @click="goDownload(item.filePath)">
            <img style="margin-right:18px;" src="../../assets/down_icon.png">
            <a>Download documents</a></p>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
    export default {
        name: 'Fourth',
        props: {
          Media: {
            type: Array,
            default: () => ([])
          },
        },
        mounted() {},
        methods: {
          // 下载
          goDownload(val){
            window.open(val);
          },
          toPlays(index){ 
            console.log(this.$refs);
            const ref = this.$refs[`videoPlayer`][index]
            ref.paused === true ? ref.play() : ref.pause();
          },
        }
    }
</script>

<style scoped>
.content {
  width: 100%;
  height: auto;
}
.five {
  padding: 30px 40px 0 27px;
}
.five-item {
  display:flex;
  justify-content: center;
  margin-bottom:40px;
}
.img-sty {
    width:360px;
    height:270px;
    overflow: hidden;
    max-width:360px;
    max-height:270px;
    border-radius: 3px;
    box-shadow: 2px 2px 2px #fcfcfc;
  }
  .img-hover {
    object-fit: cover;
    transition: all 2s;
    overflow:hidden;
  }
  .img-hover :hover {
	/* 放大1.3倍 */
    transform: scale(1.2);
  }
  .img-wh {
    width:100%;
    height:auto;
    max-height:141px;
    max-width:100%;
  }
  .five-mesage {
    flex:1;
    padding-left:30px;
  }
  .p3 {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    word-break: break-all;
  }
</style>